import { render } from "./CustomRadio.vue?vue&type=template&id=11432da6&scoped=true"
import script from "./CustomRadio.vue?vue&type=script&lang=js"
export * from "./CustomRadio.vue?vue&type=script&lang=js"

import "./CustomRadio.vue?vue&type=style&index=0&id=11432da6&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11432da6"]])

export default __exports__